import { NgClass } from '@angular/common';
import { Component, Input, ViewContainerRef, output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { CandidateAnalytics } from '@recruitee/candidate-util';
import { filterBoolean } from '@recruitee/common';
import { I18nService, TranslatePipe } from '@recruitee/i18n';
import {
  ButtonComponent,
  ButtonLoadingDirective,
  DialogService,
  IconComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-candidate-duplications',
  templateUrl: './candidate-duplications.component.html',
  styleUrls: ['./candidate-duplications.component.less'],
  imports: [NgClass, ButtonComponent, ButtonLoadingDirective, IconComponent, TranslatePipe],
})
export class CandidateDuplicationsComponent {
  @Input() public id: number;
  @Input() public duplicates: number[];
  @Input() public duplicatesLimit: number = 10;
  @Input() public loading: boolean = false;

  public merge = output<number>();

  constructor(
    private dialog: DialogService,
    private i18n: I18nService,
    private viewRef: ViewContainerRef,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private analytics: CandidateAnalytics,
  ) {}

  public moveToCandidate(candidateId: number): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        candidate: candidateId,
      },
      queryParamsHandling: 'merge',
    });
  }

  public mergeClick(): void {
    this.dialog
      .information({
        message: this.i18n.translate('app.candidate.merge_confirmation_dialog.message_v2'),
        title: this.i18n.translate('app.candidate.merge_confirmation_dialog.title'),
        agreeLabel: this.i18n.translate('app.candidate.merge_confirmation_dialog.agree_label'),
      })
      .pipe(filterBoolean, take(1))
      .subscribe(() => {
        this.analytics.trackMergeCandidates(this.duplicates.length);
        this.merge.emit(this.id);
      });
  }

  public openConfirmDialog(
    message: string,
    title: string,
    variant: string = 'information',
  ): Observable<boolean> {
    return this.dialog.confirm({ title, message, variant, isCancelable: true }, this.viewRef);
  }

  public trackByDuplication(index: number, duplication: number): number {
    return duplication;
  }
}
